import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  requestResetPassword,
  resetPassword,
} from "../actions/userActions";
import background from "../images/bglogin.svg";
import Message from "../components/Message";
import Spinner from "react-bootstrap/Spinner";
import { COLORS } from "../contants/colors";
import { QUERIES } from "../contants/allConstants";
import Alert from "react-bootstrap/Alert";
import { useLanguageContext } from "../languageContext";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import moment from "moment";

import ToastContainer from "react-bootstrap/esm/ToastContainer";
import Collapse from "react-bootstrap/Collapse";
import Toast from "react-bootstrap/Toast";
import { useTranslation } from "react-i18next";

const ResetPasswordScreen = ({ history }) => {
  const [password2, setPassword2] = useState("");

  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [hide, setHide] = useState(true);
  const [hide2, setHide2] = useState(true);
  const [lang, setLang] = useState("1");
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { loading, error, userInfo, error_password } = userLogin;
  const [message, setMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const { t } = useLanguageContext();
  const { i18n } = useTranslation();

  useEffect(() => {
    const url_array = window.location.pathname.split("/");
    const token = url_array[url_array.length - 1];
    setToken(token);
    const savedLang = JSON.parse(localStorage.getItem("langAnisso"));
    if (!savedLang) {
      localStorage.setItem("langAnisso", JSON.stringify({ lang: "it" }));
    }
    const lang = savedLang ? savedLang.lang : "it";
    if (lang === "fr") setLang("2");
    else if (lang === "en") {
      setLang("0");
    } else {
      setLang("1");
    }
  }, []);

  useEffect(() => {
    moment.locale("en");
    if (userInfo) {
      if (!userInfo.isBlocked) history.push("/dashboard/"); //to redirect if the user is loggedin
    }
  }, [history, userInfo]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (password == password2) {
      dispatch(
        resetPassword(token, password, () => {
          setMessage(t("successChangePswd"));
          setToastType("success");
          setPassword("");
          setPassword2("");
        })
      );
    } else {
      setMessage(t("pswdnotmatch"));
      setToastType("danger");
    }
  };
  useEffect(() => {
    if (error_password) {
      setMessage(t("invalidExpired"));
      setToastType("danger");
    }
  }, [error_password]);

  useEffect(() => {
    setTimeout(() => {
      setToastType("");
    }, 6000);
  }, [toastType]);
  return (
    <Wrapper>
      <Container>
        <Form>
          <Title>{t("changepwd")}</Title>
          <InputWrapper>
            <Label>{t("password")}</Label>
            <Eye
              dir={i18n.language === "ar" ? "rtl" : "ltr"}
              src={
                require(hide ? "../images/eye-off.svg" : "../images/eye-on.svg")
                  .default
              }
              alt=""
              onClick={() => setHide(!hide)}
            />
            <Input
              value={password}
              type={hide ? "password" : "text"}
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputWrapper>
          <InputWrapper>
            <Label>{t("confirmpassword")}</Label>
            <Eye
              dir={i18n.language === "ar" ? "rtl" : "ltr"}
              src={
                require(hide2
                  ? "../images/eye-off.svg"
                  : "../images/eye-on.svg").default
              }
              alt=""
              onClick={() => setHide2(!hide2)}
            />
            <Input
              value={password2}
              type={hide2 ? "password" : "text"}
              onChange={(e) => setPassword2(e.target.value)}
            />
          </InputWrapper>
          {error && <Message variant="danger">{error}</Message>}
          {userInfo
            ? userInfo.isBlocked && (
                <Message variant="danger">{t("blockedError")}</Message>
              )
            : null}

          <Button onClick={submitHandler}>
            {loading ? (
              <Spinner animation="border" variant="light" />
            ) : (
              t("changepwd")
            )}
          </Button>
          <Link href={"/dashboard/login"} target="_blank">{t("Login")}</Link>

          {toastType !== "" && (
            <ToastContainer
              containerPosition="sticky"
              position="top-end"
              style={{
                position: "fixed !important",
                bottom: "40%",
                right: 0,
                zIndex: "2000",
                float: "right",
                textAlign: "left",
              }}
            >
              <Toast
                delay={7000}
                animation
                transition={Collapse}
                bg={toastType}
                style={{
                  borderRadius: "4px",
                  fontFamily: "Din",
                  padding: "0 30px",
                }}
              >
                <Toast.Body className={"text-white"}>{message}</Toast.Body>
              </Toast>
            </ToastContainer>
          )}
        </Form>
      </Container>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${COLORS.primary};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Rady";
`;
const Title = styled.p`
  color: ${COLORS.orange};
  font-weight: bold;
  cursor: pointer;
  font-size: 1.5rem;
  padding-bottom: 25px;
`;
const Container = styled.div`
  position: "relative";
  width: 90vw;
  height: 85vh;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 30px 60px 4px rgba(57, 57, 57, 0.3);
  display: flex;
  padding: 25px;
  justify-content: space-evenly;
  @media (${QUERIES.tabletAndDown}) {
    flex-direction: column;
    align-items: center;
    /* justify-content: space-between; */
    padding: 10px 25px 40px 25px;
  }
`;
const Link = styled.a`
  color: ${COLORS.primary};
  cursor:pointer;
  font-size:0.9rem;
  margin-top:15px;
  &:hover {
  color: ${COLORS.darkBlue}
  }
`;
const Image = styled.img`
  width: 50%;
  object-fit: fill;
  /* @media (${QUERIES.tabletAndDown}) {
    height: 40%;
    width: 100%;
    margin-bottom: 10px;
  } */
  @media (${QUERIES.tabletAndDown}) {
    display: none;
  }
`;

const Icon = styled.img`
  width: 40vw;
  max-width: 180px;
  object-fit: fill;
  margin-bottom: 25px;
`;
const Flag = styled.img`
  /* width: 40px; */
  object-fit: fill;
  @media (${QUERIES.mobileAndDown}) {
    width: 30px;
  }
`;
const Eye = styled.img`
  width: 19px;
  object-fit: fill;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: ${(p) => (p.dir == "ltr" ? "40px" : "auto")};
  left: ${(p) => (p.dir == "ltr" ? "auto" : "40px")};
`;
const Form = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
`;

const Button = styled.button`
  background-color: #f77847;
  border-radius: 8px;
  font-size: 0.975rem;
  color: white;
  font-weight: 700;
  width: 100%;
  height: 48px;
  border: none;
  margin-top: 25px;
  &:hover {
    outline: none;
    background-color: #f6936c;
  }
  &:focus {
    outline: none;
  }
  @media (${QUERIES.mobileAndDown}) {
    margin-top: 15px;
  }
`;

const InputWrapper = styled.div`
  border: 1px solid ${COLORS.gray20};
  border-radius: 4px;
  padding: 10px 12px;
  width: 100%;
  margin-bottom: 30px;
  position: relative;
  @media (${QUERIES.mobileAndDown}) {
    margin-bottom: 20px;
  }
`;
const Label = styled.p`
  font-size: 0.6875rem;
  color: ${COLORS.black56};
  font-weight: 400;
  /* text-align: right; */
  margin: 0 0 4px 0;
`;
const Input = styled.input`
  font-size: 0.875rem;
  color: ${COLORS.black56};
  font-weight: 700;
  border: none;
  /* text-align: right; */
  width: 100%;

  &:focus {
    border: none;
    outline: none;
  }
`;
export default ResetPasswordScreen;
